const ChevronUpZip = ({ ...props }) => {
  return (
    <svg
    width={24}
    height={24}
    viewBox="0 0 1280 1280"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M623 322.3c-3.6 1.2-9 3.7-12 5.6-3.7 2.3-84.1 82-247.3 245C230.8 705.8 122 814.9 122 815.5c0 1.3 74.2 75.5 75.5 75.5.5 0 100.3-99.3 221.7-220.7L640 449.5l220.8 220.8C982.2 791.7 1082 891 1082.5 891c1.3 0 75.5-74.2 75.5-75.5 0-.6-108.6-109.5-241.2-242.2-180.3-180.1-242.9-242.2-247.7-245.2-9.3-6-17.2-8.1-29.5-8.1-7.8 0-11.6.6-16.6 2.3z" />
  </svg>
  )
}

export default ChevronUpZip
